import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { LEGAL_LINKS_KEY, legalApi } from '../api/legal';

/** Footer links to the legal pages that are written (doc 63); nothing while none is. */
export function LegalLinks() {
  const links = useQuery({ queryKey: LEGAL_LINKS_KEY, queryFn: legalApi.links, staleTime: 5 * 60_000, retry: false });
  const pages = links.data?.pages ?? [];
  if (pages.length === 0) return null;
  return (
    <footer className="site-footer">
      <nav aria-label="Legal">
        {pages.map((p) => <Link key={p.key} to={`/legal/${p.key}`}>{p.title}</Link>)}
      </nav>
    </footer>
  );
}
